import React, { useState, useEffect } from 'react';
import CustomDialog from '../components/CustomDialog';
import AdminNav from './AdminNav';
import './AdminLayout.css';
import './AdminTable.css';

import { API, authHeadersOnly } from '../services/apiConfig';

function ManageUsers() {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [dialog, setDialog] = useState(null);

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    filterUsers();
  }, [searchTerm, users]);

  const fetchUsers = async () => {
    try {
      const response = await fetch(`${API}/api/auth/users`, { headers: authHeadersOnly() });
      const data = await response.json();
      setUsers(data);
      setFilteredUsers(data);
    } catch (error) {
      console.error('Error fetching users:', error);
      setUsers([]);
    }
  };

  const filterUsers = () => {
    if (searchTerm) {
      const filtered = users.filter(u => 
        u.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        u.email?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredUsers(filtered);
    } else {
      setFilteredUsers(users);
    }
  };

  const deleteUser = async (id) => {
    setDialog({
      message: 'Are you sure you want to delete this user?',
      type: 'confirm',
      onClose: () => setDialog(null),
      onConfirm: async () => {
        try {
          await fetch(`${API}/api/auth/users/${id}`, { method: 'DELETE', headers: authHeadersOnly() });
          setDialog({ message: 'User deleted successfully', type: 'success', onClose: () => setDialog(null) });
          fetchUsers();
        } catch (error) {
          setDialog({ message: 'Failed to delete user', type: 'error', onClose: () => setDialog(null) });
        }
      }
    });
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  };

  return (
    <>
      <AdminNav onLogout={handleLogout} />
      <div className="admin-page-wrapper">
        <div className="admin-page-container">
          
          <div className="admin-page-header">
            <h1 className="admin-page-title">Manage Users</h1>
            <p className="admin-page-subtitle">View, search and manage all registered users</p>
          </div>

          <div className="admin-search-filter-card">
            <input
              type="text"
              placeholder="🔍 Search users by name or email..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="admin-search-input"
            />
          </div>

          <div className="admin-table-card">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.map((user) => (
                  <tr key={user.id}>
                    <td>#{user.id}</td>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>
                      <span className={`admin-status-badge ${user.role?.toLowerCase()}`}>
                        {user.role}
                      </span>
                    </td>
                    <td>
                      <button
                        className="admin-table-btn delete"
                        onClick={() => deleteUser(user.id)}
                      >
                        🗑️ Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {filteredUsers.length === 0 && (
            <div className="admin-empty-state">
              <i className="fas fa-users"></i>
              <p>No users found</p>
            </div>
          )}

        </div>
      </div>
      {dialog && <CustomDialog message={dialog.message} type={dialog.type} onClose={dialog.onClose} onConfirm={dialog.onConfirm} />}
    </>
  );
}

export default ManageUsers;
